import * as THREE from 'three';

import { Camera } from '../Camera/Camera';

const MIN_CAMERA_DISTANCE = 1.1;
const MAX_CAMERA_DISTANCE = 4;

// Frame the subject around waist height so the camera starts looking at the
// body instead of the floor at the origin.
const DEFAULT_PAN_CENTER = new THREE.Vector3(0, 1, 0);

export type OrbitCameraProps = {
    onRotate?: () => void;
    enabled?: boolean;
    forcedAzimuthalAngle?: number | null;
    forcedPolarAngle?: number | null;
};

/**
 * Free-orbit camera — a thin assembly over the shared Camera rig.
 * Focus targets and transient "snap" directives (presets, static angle locks)
 * get layered on here later; for the prototype it's just free orbit.
 */
export function OrbitCamera({
    onRotate,
    enabled = true,
    forcedAzimuthalAngle = null,
    forcedPolarAngle = null,
}: OrbitCameraProps) {
    return (
        <Camera
            enabled={enabled}
            forcedAzimuthalAngle={forcedAzimuthalAngle}
            forcedPolarAngle={forcedPolarAngle}
            minDistance={MIN_CAMERA_DISTANCE}
            maxDistance={MAX_CAMERA_DISTANCE}
            panBoundsCenter={DEFAULT_PAN_CENTER}
            enablePan
            onRotate={onRotate}
        />
    );
}
